import { createApp } from '@backstage/frontend-defaults';
import { apisModule } from './modules/apis';
import {
  dependenciesContentModule,
  relationsRedirectModule,
  jiraApiModule,
  jiraCardModule,
  mermaidAddonModule,
} from './modules/entityPage';
import { navModule } from './modules/nav';
import {
  catalogEntityPageModule,
  catalogGraphPageModule,
  explorePageModule,
  homePageModule,
  searchPageModule,
  techDocsPageModule,
  toolboxPageModule,
} from './modules/pages';
import { signInPageModule } from './modules/signInPage';
import { themesModule } from './modules/themes';
import { adrTranslationModule } from './modules/translations';
import toolboxPlugin from '@drodil/backstage-plugin-toolbox/alpha';

const app = createApp({
  features: [
    // Core app modules
    apisModule,
    navModule,
    signInPageModule,
    themesModule,

    // Custom page overrides
    catalogEntityPageModule,
    catalogGraphPageModule,
    explorePageModule,
    homePageModule,
    searchPageModule,
    techDocsPageModule,
    toolboxPageModule,

    // Translations
    adrTranslationModule,

    // Toolbox
    toolboxPlugin,

    // Entity page modules
    mermaidAddonModule,
    jiraApiModule,
    jiraCardModule,
    dependenciesContentModule,
    relationsRedirectModule,
  ],
});

export default app.createRoot();
